import { getRefreshTokenLocalStorage } from "./../utils/token";
import { createSlice } from "@reduxjs/toolkit";
import { RootState } from "app/store";
import { User } from "services/auth";
import { RoleType } from "services/login";
import { getAccessTokenLocalStorage } from "utils/token";

export interface CounterState {
  accessToken: string;
  refreshToken: string;
  role?: RoleType;
  user?: User;
}

const initialState: CounterState = {
  accessToken: getAccessTokenLocalStorage() || "",
  refreshToken: getRefreshTokenLocalStorage() || "",
};

export const authUserSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setAccessToken: (state, { payload }) => {
      state.accessToken = payload.accessToken;
    },
    setRefreshToken: (state, { payload }) => {
      state.refreshToken = payload.refreshToken;
    },
    setRole: (state, { payload }) => {
      state.role = payload.role;
    },
    setMe: (state, { payload }) => {
      state.user = payload.user;
    },
    removeToken: (state) => {
      state.accessToken = "";
      state.refreshToken = "";
      state.role = undefined;
      state.user = undefined;
      localStorage.removeItem("accessToken");
      localStorage.removeItem("refreshToken");
    },
  },
});

// Action creators are generated for each case reducer function
export const { setAccessToken, setRefreshToken, removeToken, setRole, setMe } =
  authUserSlice.actions;

export const useSelectAuthUser = (state: RootState) => state.authUser;

export default authUserSlice.reducer;
